import styled from 'styled-components';

import { Color } from '../../../shared/constants/Colors';
import { Shadow, Transition } from '../../../shared/constants/Styles';

export const DesktopContainer = styled.div`
  width: ${({ isFullWidth }) => (isFullWidth ? '100%' : 'initial')};
  display: flex;
  position: relative;
`;

export const Wrapper = styled.div`
  width: ${({ isFullWidth }) => (isFullWidth ? '100%' : 'initial')};
  display: flex;
  align-item: center;
`;

export const Drawer = styled.div`
  display: flex;
  position: absolute;
  justify-content: center;
  min-width: 100%;
  width: auto;
  width: max-content;
  height: auto;
  top: calc(100% + 10px);
  left: 50%;
  transition: ${Transition.OPACITY_EASE};
  transform-origin: top;
  background-color: ${Color.WHITE};
  padding: 12px 0;
  border-radius: 5px;
  z-index: 100;
  box-shadow: ${Shadow.BOX_ACTIVE};
  visibility: ${({ isOpen }) => (isOpen ? 'visible' : 'hidden')};
  transform: ${({ isOpen }) =>
    isOpen ? `scale(1) translateX(-50%)` : 'scale(0)'};
  opacity: ${({ isOpen }) => (isOpen ? '1' : '0')};

  &::after {
    content: '';
    position: absolute;
    background-color: transparent;
    width: 100%;
    height: 10px;
    top: -10px;
    left: 0;
    z-index: 1;
  }

  &::before {
    content: '';
    position: absolute;
    height: 15px;
    width: 15px;
    border-top-left-radius: 3px;
    background-color: ${Color.WHITE};
    top: 2px;
    left: 50%;
    z-index: 102;
    transform: translate(-50%, -50%) rotate(45deg);
  }
`;
